import { Typography } from 'antd';
import { useIntl } from 'react-intl';
import { TypedFormatMessageFn } from '@app-types/intl';

export const EvidenceCompletedBadge = () => {
  const { formatMessage }: { formatMessage: TypedFormatMessageFn } = useIntl();

  return (
    <div className='shrink-0 rounded-xl bg-green-500 px-2.5 py-1 text-white'>
      <Typography.Text className='leading-5 text-xs font-normal text-white'>
        {formatMessage({ id: 'evidence.section.completedBadge' })}
      </Typography.Text>
    </div>
  );
};
